/**
 * Reports whether a caught error (or its RxDB-wrapped cause) is a browser storage-quota exhaustion failure.
 */
export function isQuotaExceededError(error: unknown): boolean {
    if (error instanceof DOMException) {
        return error.name === 'QuotaExceededError';
    }

    if (error instanceof Error) {
        return isQuotaExceededError(error.cause);
    }

    if (error && typeof error === 'object' && 'parameters' in error) {
        const parameters = (error as { parameters?: { errors?: unknown[] } }).parameters;

        return (parameters?.errors ?? []).some((nested) => isQuotaExceededError(nested));
    }

    return false;
}
